import React from 'react';
import { sendChatComposerIntakeQLead } from '../../../../redux/leadModalActions.js';
import GenericLeadSyncComposer from '../GenericLeadSyncComposer.js';

const IntakeQAddLeadComposer = () => {
  return <GenericLeadSyncComposer id={'intake-q'} title={'IntakeQ'} syncMethod={sendChatComposerIntakeQLead} />;
};

export default IntakeQAddLeadComposer;
